import { useMemo } from "react";
import { useStaffAnnotatorsQuery } from "../api";

export function useAnnotatorData() {
  const { data: annotatorsData } = useStaffAnnotatorsQuery();

  const annotatorList = useMemo(
    () =>
      annotatorsData?.results.map((annotator) => ({
        key: annotator.id,
        value: `${annotator.first_name} ${annotator.last_name}`,
      })) || [],
    [annotatorsData]
  );

  const annotatorOptions = useMemo(
    () =>
      annotatorList.length > 0
        ? [{ key: "null", value: "None" }, ...annotatorList]
        : [{ key: "null", value: "None" }],
    [annotatorList]
  );

  const annotatorLookup = useMemo(
    () =>
      annotatorsData?.results.reduce(
        (acc, annotator) => {
          acc[annotator.id] = `${annotator.first_name} ${annotator.last_name}`;
          return acc;
        },
        {} as Record<string, string>
      ) || {},
    [annotatorsData]
  );

  return {
    annotatorOptions,
    annotatorLookup,
  };
}
